// extracted by mini-css-extract-plugin
export default {"table":"LeadsTable_table__f-wzQ","plusIcon":"LeadsTable_plusIcon__Dp3BC"};